import { Component, OnInit, Input } from '@angular/core';
import { AddeventService } from 'src/app/services/addevent.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'src/app/services/global.service';
import { FormControl } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@Component({
  selector: 'app-addevent',
  templateUrl: './addevent.component.html',
  styleUrls: ['./addevent.component.css']
})
export class AddeventComponent implements OnInit {

  //string
  token: string;

  //time
  
  timeStart: any;
  timeEnd: any;
  onlyStart = false;

  //Input
  @Input() start
  @Input() end

  constructor(
    private addEventService: AddeventService,
    private modalService: NgbModal,
    private globals: GlobalService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    if(!this.token){
      this.token = this.globals.getToken();
    }
    this.change();
  }

  change(){
    if(this.end){
      this.onlyStart = false;
    } else {
      this.onlyStart = true;
    }
    console.log(this.start, this.end);
  }


  leave(){
    this.activeModal.close('cancel')
  }

  test(info, infoR){
    console.log(info, infoR);
    
  }

}
